 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		171: 0,
 		69: 0,
 		70: 0,
 		77: 0,
 		78: 0,
 		79: 0,
 		80: 0,
 		124: 0,
 		125: 0,
 		132: 0,
 		133: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~df3bb2ca","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","6":"AddClosedAlertIDUseCase","7":"CreateDeviceUseCase","8":"CreateDomestikaFollowUseCase","9":"CreateJWTUserUseCase","10":"CreateUserLiveSessionUseCase","11":"CurrentUserUseCase","12":"CurrentWithoutRelationshipsUserUseCase","13":"DeleteDeviceUseCase","14":"DeleteFollowUseCase","15":"ENV_CONFIG1","16":"ENV_CONFIG4","17":"ENV_CONFIG5","18":"ENV_CONFIG6","19":"ENV_CONFIG7","20":"FinishUserLiveSessionUseCase","21":"GetAccessTokenUserUseCase","22":"GetAdvanceGDPRStatusUserUseCase","23":"GetAllBlogUseCase","24":"GetAreasCourseUseCase","25":"GetCartCourseUseCase","26":"GetCategoriesCourseUseCase","27":"GetCourseUseCase","28":"GetFinalProjectVideoByCourseIDCourseUseCase","29":"GetGDPRStatusUserUseCase","30":"GetListLiveFeedbackQuestionUseCase","31":"GetListLiveSessionUseCase","32":"GetListLiveStreamUseCase","33":"GetLiveChannelUseCase","34":"GetLiveSessionUseCase","35":"GetOrganizationUseCase","36":"GetPlusPromotionUseCase","37":"GetPostContentBlogUseCase","38":"GetPromotionCodeAlertUseCase","39":"GetPromotionUseCase","40":"GetPubnubCredentialsUseCase","41":"GetSessionDataUserUseCase","42":"GetSimpleUserUseCase","43":"GetSoftwaresCourseUseCase","44":"GetUserAlertUseCase","45":"GetVideoProgressListCourseUseCase","46":"GetVideoSpeedUserUseCase","47":"GetVideoVolumeUserUseCase","48":"LogoutUserUseCase","49":"PathToRegexp","50":"RefreshAccessTokenUserUseCase","51":"RemoveAccessTokenUserUseCase","52":"SearchCourseUseCase","53":"SendHeaderTrackingUseCase","54":"SendLiveFeedbackAnswersUseCase","55":"SendPlayerTrackingUseCase","56":"SendTrackingUseCase","57":"SendVideoProgressCourseUseCase","58":"SetAdvanceGDPRStatusUserUseCase","59":"SetGDPRStatusUserUseCase","60":"SetVideoSpeedUserUseCase","61":"SetVideoVolumeUserUseCase","62":"UpdateLanguageUserUseCase","63":"UpdateLiveSessionUseCase","64":"UpdateVideoAudioAndSubtitlesCourseUseCase","65":"UpdateVideoProgressCourseUseCase","66":"ViewPageTrackingUseCase","134":"vendors~AddClosedAlertIDUseCase","135":"vendors~AlgoliaSearch","136":"vendors~AmplitudeJS","137":"vendors~GetAdvanceGDPRStatusUserUseCase","138":"vendors~RemoveAccessTokenUserUseCase","139":"vendors~SearchCourseUseCase","140":"vendors~SetGDPRStatusUserUseCase","141":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"3ab77c17fc08e3531ffd","1":"8338582f3afc308190fe","2":"dbb5d7606a50b1709a07","3":"ba5ab7a55c1c54f00a32","4":"6ef666fd47ce2328bca4","5":"a727afb2e16b4d1d8a26","6":"b255adbe905834c2e266","7":"41d5ece2f2f623ab6990","8":"19ccc0a022389ca01264","9":"8c0c67d8bf7ba5b6ca6f","10":"5f7f92c99dfe41e2a99c","11":"620523c2af3f53a2107d","12":"89fa42f23b9715336535","13":"a4a2c844b8801d535354","14":"5c85ba8b6c3754c6bf41","15":"19d553b1eb98aa0b4112","16":"5dd0dcd23d1cb1a0950a","17":"a37de5443c3a76a5c739","18":"362a1a15b9f0872b1ee8","19":"66adf62703c6693d0af8","20":"2bd6a68052c951d1969b","21":"b6017734f844bb0ac263","22":"804ae23273ee1b516718","23":"2baac02e103284df1dc6","24":"5f8f8c75ae4d3644fba5","25":"53125e9406c874039d14","26":"8d8e616bad24edb17890","27":"74a1b5a70089d86fd872","28":"d430aaa4b5fca69b78c5","29":"50b75d5ab79e6227f8c4","30":"7ad441a7f2e2f94fda03","31":"e115b60de9910bfdcd32","32":"a9f69d2edb45a8625166","33":"52df5bf4f08329baf2ec","34":"4d149bad95d0700f78f2","35":"52341b7e7919ffc7c4fe","36":"4e5f4dc985d4078124f6","37":"a3fe71b2d02238df54c3","38":"d6d9fb0a2ae19306a47c","39":"98d5bcfcce400a2d81bf","40":"5ae0e2ffcefdbf32dd31","41":"0b98ba6b1dc4b64fe782","42":"22a752a78f079d17831e","43":"9d54382c0d2cff5d3b30","44":"902e72c04c9abea4fbcd","45":"e01a1fc0676ab847c8a5","46":"ae1c1fe4b8cf18c69c60","47":"23ad2ca13ceb8a899ce8","48":"0213a263e4fffa06692c","49":"fe0ae0e94dccf31e3c63","50":"579e6ae31c76c7a07006","51":"6fe3b08b60b09fabe5b8","52":"527657762f4f8f7cf787","53":"e8e78759f3ad8dbc25ce","54":"04d09509a03030110170","55":"b70d59bc6e6b599dbc2c","56":"da2d3ee31d8635711b1d","57":"47cbd26f62f28f0713ac","58":"930b2daf54974acba550","59":"cf742eba5a4e5caa6e25","60":"d59bac765ee30de9b96a","61":"7368ba10b8618e6eb57a","62":"5ecf8475b8e2c878ddb5","63":"c8a94527bba6ba2f7260","64":"30a11d18f1a3111bb4c0","65":"837d0cc508bcf3a45d70","66":"8017cfb96d5810446331","134":"2a1562b349fe7ba7052b","135":"ab910bc68bbfc3e48beb","136":"e782180eddd228088ac7","137":"1fd05217da821e5fbe1e","138":"1c0e5676a8b6998b2736","139":"d826ebe3097ba6e83181","140":"2b152d7551a2a54b37cd","141":"2d1ca200a3157af8d655","203":"f3da07e1317341a74631","205":"75afeaf9955ddb4d4a84","206":"d1ee6cead798b1279934","207":"9387b496a8d2fd28b77c"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 338);
